/* pantallas-alumno (B): EL RENGLON DE DOCUMENTO (piezas nuevas de la parte 1, P6 y P8).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Alto minimo 56, relleno 0 14, fondo #101010, borde #1F1F1F, radio 12, separacion 8 entre renglones
   (`LISTA_DE_RENGLONES`). Casilla; icono de tipo de 32 (personas para una publicacion; en el celular
   no va); el nombre de 15 px; chip opcional; conteo de 12.5 px #8A8A8A con numeros tabulares.
   Marcado: fondo #17100B y borde #F27A2E (era #3A2414; centro-espacio). El area tactil es TODO el renglon (`role="checkbox"`).

   P6: en computadora el nombre va en un renglon con "..." y se ve completo al pasar el mouse
   (`title`, solo si esta cortado: centro-espacio); en el celular usa hasta dos renglones y luego "...". Se parte de preferencia despues de
   "_" o "." (`nombreConCortes` de la tarjeta del Panel).

   P8 (`bloqueado`): con candado y apagado (45 %); no se marca, y tocarlo llama a `alTocarBloqueado`
   (que saca el aviso de hoy). `apagado` sin candado sirve igual (por ejemplo, la app sin red).

   centro-espacio (orden de Carlos del 20-oct), ELEGIR:
   - Marcado: el borde en el naranja de la tarjeta de modo elegida (#F27A2E; era #3A2414, casi invisible), con el
     fondo de hoy y la casilla naranja.
   - Un doble clic del MOUSE (el gesto de "abrir" de la computadora) cuenta como UN clic: antes elegia y quitaba a la
     vez y el renglon quedaba vacio con el foco encima. Lo segundo del doble clic (`detail` 2 o mas) no hace nada. Con
     el dedo cada toque cuenta (Chrome tambien numera dos toques seguidos).
   - El foco: con el teclado, un anillo de 1 px gris POR DENTRO del borde (la lista se desplaza y corta lo que sale
     de su orilla). Con el mouse o el dedo no se pinta nunca: el renglon apunta `data-puntero` (el tipo de puntero) al apretar y lo suelta
     con una tecla o al perder el foco.
   - La etiqueta flotante del nombre (`title`) solo se pone si el nombre esta cortado con "..." al pasar el mouse. */
import React from 'react';
import { Lock, Users } from 'lucide-react';
import Casilla from './Casilla';
import { IconoDelTipo } from '../panel/tipoDelDocumento';
import { nombreConCortes } from '../panel/anatomia';

export const LISTA_DE_RENGLONES = 'flex flex-col gap-2';

export default function RenglonDeDocumento({
  nombre, claveTipo = 'pdf', publicacion = false, chip, conteo, marcado = false, bloqueado = false, apagado = false,
  onAlternar, alTocarBloqueado, testid, className = '',
}) {
  const inerte = bloqueado || apagado;
  const alTocar = (e) => {
    if (e && e.detail > 1 && e.currentTarget && e.currentTarget.dataset.puntero === 'mouse') return;
    if (inerte) { if (alTocarBloqueado) alTocarBloqueado(); return; }
    if (onAlternar) onAlternar();
  };
  const caja = marcado && !inerte ? 'bg-[#17100B] border-[#F27A2E]' : 'bg-[#101010] border-[#1F1F1F] hoverable:border-[#2C2C2C]';
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={marcado && !inerte}
      aria-disabled={inerte || undefined}
      onClick={alTocar}
      onPointerDown={(e) => { e.currentTarget.dataset.puntero = e.pointerType || 'mouse'; }}
      onKeyDown={(e) => { delete e.currentTarget.dataset.puntero; }}
      onBlur={(e) => { delete e.currentTarget.dataset.puntero; }}
      onPointerEnter={(e) => {
        const n = e.currentTarget.querySelector('[data-parte="nombre"]');
        if (!n) return;
        if (n.scrollHeight > n.clientHeight + 1 || n.scrollWidth > n.clientWidth + 1) n.title = nombre;
        else n.removeAttribute('title');
      }}
      data-testid={testid}
      className={`w-full min-h-[56px] px-[14px] py-2 flex items-center gap-3 text-left rounded-xl border ${caja}${inerte ? ' opacity-45 cursor-not-allowed' : ' active:brightness-90'} focus:outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-[#9A9A9A] data-[puntero]:!ring-0${className ? ` ${className}` : ''}`}
    >
      {bloqueado
        ? <span data-parte="candado" aria-hidden="true" className="w-[22px] h-[22px] shrink-0 flex items-center justify-center"><Lock className="w-4 h-4 text-[#9A9A9A]" /></span>
        : <Casilla marcada={marcado && !inerte} />}
      <span data-parte="icono" data-tipo={publicacion ? 'publicacion' : claveTipo} aria-hidden="true"
        className="max-md:hidden w-8 h-8 shrink-0 rounded-[9px] bg-[#1C130D] flex items-center justify-center">
        {publicacion ? <Users className="w-4 h-4 text-[#F7A06A]" /> : <IconoDelTipo clave={claveTipo} className="w-4 h-4 text-[#F7A06A]" />}
      </span>
      <span data-parte="nombre"
        className="flex-1 min-w-0 text-[15px] leading-5 text-[#F4F4F3] break-words line-clamp-2 md:line-clamp-1 md:break-all">
        {nombreConCortes(nombre)}
      </span>
      {chip ? <span className="shrink-0">{chip}</span> : null}
      {conteo ? <span data-parte="conteo" className="shrink-0 text-[12.5px] text-[#8A8A8A] tabular-nums whitespace-nowrap">{conteo}</span> : null}
    </button>
  );
}
